import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AdminListingDto, AdminTagDto } from 'services/data-contracts';
import { useNavigate } from 'react-router-dom';
import { Row } from 'saladsoft-primitive';
import Text from 'components/commons/Text';
import ServiceHelper from 'stores/ServiceHelper';

interface GridItemProps {
  listing: AdminListingDto;
}

const GridItem = ({ listing }: GridItemProps) => {
  const navigate = useNavigate();

  const [tags, setTags] = useState<AdminTagDto[]>([]);

  useEffect(() => {
    if (listing) {
      ServiceHelper?.adminListingService?.getTagsByListing1(listing?.id as number).then((res) => {
        setTags(res.data);
      });
    }
  }, [listing]);

  return (
    <ItemContainer
      key={listing.id}
      onClick={() => {
        navigate(`/admin/listings/${listing.id}/photos`);
      }}
    >
      <ItemLayout>
        <ActiveWrapper active={listing.isActive}>
          <Row>
            <>{listing?.isActive && <>운영중</>}</>
          </Row>
        </ActiveWrapper>
        <img
          src={listing?.images?.[0]?.thumbnailUrl || '/images/butlerleelogo.png'}
          alt={`Image ${listing.id}`}
          className={!listing?.images?.[0]?.thumbnailUrl ? 'default-image' : ''}
          style={{
            width: '100%',
            height: '100%',
            maxHeight: 230,
            objectFit: 'cover',
          }}
        />
      </ItemLayout>
      <div style={{ padding: 10 }}>
        <Row width="100%" justifyContent="space-between">
          <Text type="H2">{listing?.localizedName?.['ko']}</Text>
          {listing?.hostawayId ? (
            <HostawayIdWrapper>
              HA - <b>{listing?.hostawayId}</b>
            </HostawayIdWrapper>
          ) : (
            <></>
          )}
        </Row>
        <Text type="H3" style={{ fontWeight: 400, margin: '10px 0' }}>
          {listing?.localizedTitle?.['ko']?.replace(/\\r\\n/g, '')}
        </Text>
        <Row gap="10px" justifyContent="flex-start" marginBottom="10px" flexWrap="wrap">
          {tags.map((tag) => (
            <TagWrapper key={tag.id}>#{tag.localizedName?.['ko']}</TagWrapper>
          ))}
        </Row>
        <Text type="H5" buttonRole="DESCRIPTION">
          {listing?.localizedAddress?.['ko']}
        </Text>
      </div>
    </ItemContainer>
  );
};

const ItemContainer = styled.div`
  flex: 1 1 350px;
  min-width: 0;
  max-width: 400px;
  width: calc((100% - 40px) / 3);
  transition: transform 0.1s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 1200px) {
    width: calc((100% - 20px) / 2);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ItemLayout = styled.div`
  border-radius: 10px;
  overflow: hidden;
  height: 230px;
  background-color: #f0f0f0;
  position: relative;
  img.default-image {
    opacity: 0.4;
    width: 200px !important;
    margin: 0 auto;
    display: block;
    object-fit: contain !important;
  }
`;

const ActiveWrapper = styled.div<{ active?: boolean }>`
  position: absolute;
  top: 10px;
  left: 10px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  background: ${(props) => (props.active ? '#7c0000' : 'transparent')};
  padding: 5px 10px;
  /* background: red !important; */
`;

const HostawayIdWrapper = styled.div`
  background: #e7e7e7;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
`;

const TagWrapper = styled.div`
  background: #fffbde;
  padding: 5px 10px;
  border-radius: 10px;
  display: inline-block;
`;

export default GridItem;
